module.exports = __webpack_public_path__ + "static/media/Mystino-home-m.02ffa361.jpg";